module.exports = __webpack_public_path__ + "img/home_bg.3e799ebc.jpg";